import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { HttpService } from '@core/shared';
import { UrlBuilder, GET_LEADERBOARD_QUARTERS, GET_SELECT_PARTNERS_LEADERBOARD_DATA, GET_3M_CARCARE_LEADERBOARD_DATA } from '@core/core-api-variables';

@Injectable()
export class LeaderboardService {
    constructor(public http: HttpService) { }

    getLeaderboardData(type, data) {
        const url = type == '3m' ? UrlBuilder(GET_3M_CARCARE_LEADERBOARD_DATA, data) : UrlBuilder(GET_SELECT_PARTNERS_LEADERBOARD_DATA, data);
        return this.http.get(url).pipe(map((response: any) => {
            return response;
        }));
    }

    getLeaderboardQuarters() {
        return this.http.get(GET_LEADERBOARD_QUARTERS).pipe(map((response: any) => {
            return response;
        }));
    }

}